import Vue from 'vue'
import App from './App.vue'
import './plugins/bootstrap';
import store from "@/store";
import VueMeta from "vue-meta";
import VueYandexMetrika from 'vue-yandex-metrika'    

const VueCookie = require('vue-cookie');
Vue.use(VueCookie);
Vue.use(VueMeta);

Vue.config.productionTip = false

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.use(VueYandexMetrika, {
  id: 88139316,
  env: 'production'
})

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')